export default __webpack_public_path__ + "static/media/meet-and-greet-benefit.90db4027.svg";